import React from 'react';
import {Path} from "../../components/svg/components/path";
import {Svg} from "../../components/svg/components/Svg";
import styles from "./keyboard-arrow.module.scss";
import classNames from "classnames";

export const KeyboardArrowRight = ({className, style, onClick}) => {
  return <Svg className={classNames(className, styles.default)} style={style} onClick={() => onClick && onClick()}>
    <Path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
  </Svg>
}
